var _circle, _ellipse, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _ellipse2, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _ellipse3, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _ellipse4, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 95,
    viewBox: "0 0 372 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 172.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 172.5 89.5)",
    fill: "url(#paint0_linear_17479_43681)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 89.5,
    rx: 5.5,
    ry: 6,
    transform: "rotate(90 200 89.5)",
    fill: "#E2E2E2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 227.5 89.5)",
    fill: "#E2E2E2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 144.5 89.5)",
    fill: "#B19293"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 116.5 89.5)",
    fill: "#B19293"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 88.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 88.5 89.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 61.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 61.5 89.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 33.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 33.5 89.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 5.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 5.5 89.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(90 172.5 61.5)",
    fill: "url(#paint1_linear_17479_43681)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 61.5,
    rx: 5.5,
    ry: 6,
    transform: "rotate(90 200 61.5)",
    fill: "#E2E2E2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(90 227.5 61.5)",
    fill: "#E2E2E2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(90 144.5 61.5)",
    fill: "#B09293"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(90 116.5 61.5)",
    fill: "#B09293"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 88.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(90 88.5 61.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 61.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(90 61.5 61.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 33.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(90 33.5 61.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 5.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(90 5.5 61.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(90 172.5 33.5)",
    fill: "url(#paint2_linear_17479_43681)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 33.5,
    rx: 5.5,
    ry: 6,
    transform: "rotate(90 200 33.5)",
    fill: "#E2E2E2"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(90 227.5 33.5)",
    fill: "#E2E2E2"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(90 144.5 33.5)",
    fill: "#AF9192"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(90 116.5 33.5)",
    fill: "#AF9192"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 88.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(90 88.5 33.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 61.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(90 61.5 33.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 33.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(90 33.5 33.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 5.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(90 5.5 33.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 172.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(90 172.5 5.5)",
    fill: "url(#paint3_linear_17479_43681)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 200,
    cy: 5.5,
    rx: 5.5,
    ry: 6,
    transform: "rotate(90 200 5.5)",
    fill: "#E2E2E2"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(90 227.5 5.5)",
    fill: "#E2E2E2"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(90 116.5 5.5)",
    fill: "#AF9192"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 88.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(90 88.5 5.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 61.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(90 61.5 5.5)",
    fill: "#E2E2E2",
    fillOpacity: 0.6
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 366.5 89.5)",
    fill: "#E2E2E2"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 338.5 89.5)",
    fill: "#E2E2E2"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 311.5 89.5)",
    fill: "#E2E2E2"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 283.5 89.5)",
    fill: "#E2E2E2"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.5,
    cy: 89.5,
    r: 5.5,
    transform: "rotate(90 255.5 89.5)",
    fill: "#E2E2E2"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(90 311.5 61.5)",
    fill: "#E2E2E2"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(90 283.5 61.5)",
    fill: "#E2E2E2"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.5,
    cy: 61.5,
    r: 5.5,
    transform: "rotate(90 255.5 61.5)",
    fill: "#E2E2E2"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(90 283.5 33.5)",
    fill: "#E2E2E2"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.5,
    cy: 33.5,
    r: 5.5,
    transform: "rotate(90 255.5 33.5)",
    fill: "#E2E2E2"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 366.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(90 366.5 5.5)",
    fill: "#E2E2E2"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 338.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(90 338.5 5.5)",
    fill: "#E2E2E2"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 311.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(90 311.5 5.5)",
    fill: "#E2E2E2"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 283.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(90 283.5 5.5)",
    fill: "#E2E2E2"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.5,
    cy: 5.5,
    r: 5.5,
    transform: "rotate(90 255.5 5.5)",
    fill: "#E2E2E2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17479_43681",
    x1: 172.5,
    y1: 84,
    x2: 172.5,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09293"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17479_43681",
    x1: 172.5,
    y1: 56,
    x2: 172.5,
    y2: 67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09293"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17479_43681",
    x1: 172.5,
    y1: 28,
    x2: 172.5,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09293"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17479_43681",
    x1: 172.5,
    y1: -4.76837e-7,
    x2: 172.5,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B09293"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/top.127b4ed3dcd5d2b3a517726d4bbf7684.svg";
export { ForwardRef as ReactComponent };